export default "__VITE_ASSET__BmDbWvYb__"